import * as React from 'react';
import './HowToInvest.css';

const SelectionCriteriaSectionComponent: React.StatelessComponent = () => (
  <div className="container">
    <div className="gap-20"/>
    <div className="row">
      <div className="col-sm-12">
        <h3 className="bold-subtitle">
          Criterios de selección de empresas
        </h3>
      </div>
    </div>
    <div className="gap-20"/>
    <div className="row">
      <div className="col-sm-12">
        <p className="intro">
          <strong>
            The Crowd Angel somos una plataforma de inversión online especializada en startups y scaleups. Y la
            característica que más define a estas empresas no es el tiempo que llevan en el mercado, el tamaño de la
            empresa o el uso de tecnologías innovadoras; sino su potencial de crecimiento.
          </strong>
          <br/>
          <div className="gap-20"/>
          Buscamos compañías con modelos de negocio altamente escalables que permitan multiplicar el valor de la empresa
          de manera sustancial en un periodo de entre 4-6 años.
          <br/>
          <div className="gap-20"/>
          Somos agnósticos en cuanto a los sectores en los que invertir, y por ahora nos centramos en compañías
          españolas con ambición global.
        </p>
      </div>
    </div>

    <br/><br/><br/><br/>
    <div className="row">
      <div className="col-md-12 col-xs-12 col-sm-12">
        <div className="featured c-primary">
          Clasificamos el tipo de empresas en las que invertimos en tres categorías:
        </div>
      </div>
    </div>
    <div className="gap-20"/>
    <div className="row">
      <div className="col-md-4">
        <div
          className="simple-card"
          style={{height: '319px'}}
        >
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-4"/>
            <div className="col-md-8">
              <div className="featured c-grey">Seed</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 padding-left-30">
              <img
                style={{width: '65px', height: '65px'}}
                alt="seed"
                src="/img/07_seed.svg"
              />
            </div>
            <div className="col-md-8">
              <div className="intro-card">
                <strong>Empresas en fases iniciales que ya tienen un producto o servicio lanzado al mercado</strong>, y
                pueden presentar como mínimo unos meses de datos de tracción que demuestran la aceptación inicial del
                producto por parte del mercado. Normalmente tienen una necesidad financiera total de entre 150 K€ y 500
                K€.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div
          className="simple-card"
          style={{height: '319px'}}
        >
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-4"/>
            <div className="col-md-8">
              <div className="featured c-primary">Growth</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 padding-left-30">
              <img
                style={{width: '65px', height: '65px'}}
                alt="growth"
                src="/img/08_growth.svg"
              />
            </div>
            <div className="col-md-8">
              <div className="intro-card">
                <strong>Empresas en fases que ya han superado esta fase inicial</strong>, tienen más consolidados los
                canales de captación y operaciones, y presentan unos ratios de crecimiento acelerados. Normalmente
                tienen
                una necesidad financiera total de entre 500k€ y 2M€.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div
          className="simple-card"
          style={{height: '319px'}}
        >
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-4"/>
            <div className="col-md-8">
              <div className="featured c-primary-dark">Pre-MAB</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 padding-left-30">
              <img
                style={{width: '65px', height: '65px'}}
                alt="pre-mab"
                src="/img/09_pre-mab.svg"
              />
            </div>
            <div className="col-md-8">
              <div className="intro-card">
                <strong>Empresas más consolidadas, creciendo de manera acelerada</strong>, que tienen en su roadmap la
                salida a un mercado alternativo bursátil en un plazo inferior a 2 años. La necesidad financiera es a
                partir de 500k€.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <strong>Empresas en las que NO invertimos:</strong>
      </div>
    </div>

    <div className="gap-10"/>
    <div className="row">
      <div className="col-md-3">
        <div>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-3">
              <img
                style={{width: '50px', height: '50px'}}
                alt="idea"
                src="/img/10_fase_idea.svg"
              />
            </div>
            <div
              className="col-md-8 padding-left-20"
              style={{width: '200px'}}
            >
              Empresas en fase idea.
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 padding-left-30">
        <div>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-3">
              <img
                style={{width: '50px', height: '50px'}}
                alt="sin producto"
                src="/img/11_sin_producto.svg"
              />
            </div>
            <div
              className="col-md-8 padding-left-20"
              style={{width: '200px'}}
            >
              Empresas desarrollando el producto para lanzarlo al mercado.
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 padding-left-30">
        <div>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-3">
              <img
                style={{width: '50px', height: '50px'}}
                alt="escalable"
                src="/img/12_no_escalabilidad.svg"
              />
            </div>
            <div
              className="col-md-8 padding-left-20"
              style={{width: '200px'}}
            >
              Empresas ya con producto o servicio lanzado al mercado pero que no cumple los criterios de escalabilidad.
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 padding-left-30">
        <div>
          <div className="gap-20"/>
          <div className="row">
            <div className="col-md-3">
              <img
                style={{width: '50px', height: '50px'}}
                alt="fraude"
                src="/img/13_fraude.svg"
              />
            </div>
            <div
              className="col-md-8 padding-left-20"
              style={{width: '200px'}}
            >
              Empresas que intenten buscar el fraude o realizar actividades ilegales.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="gap-30"/>
    <div className="row">
      <div className="col-md-6">
        <div className="row title-col2">
          La inversión se lleva a cabo a través de dos tipos de operación:
        </div>
        <br/>
        <div className="row title-col-green">
          Inversión en capital
        </div>
        <div className="row intro-col">
          Los inversores adquieren participaciones de la compañía a través de una ampliación de capital, a una v
          aloración definida.
        </div>
        <br/>
        <div className="row title-col-blue">
          Préstamo participativo convertible
        </div>
        <div className="row intro-col">
          Se trata de un préstamo que tiene por objetivo la conversión a capital en un plazo antes en una ampliación de
          capital posterior a un descuento de la valoración de ésta; o en su defecto, a vencimiento del plazo y en las
          condiciones estipuladas contractualmente.
        </div>
      </div>
      <div className="col-md-6 padding-left-30">
        <div className="row title-col2">
          En The Crowd Angel somos flexibles al de participar en las rondas:
        </div>
        <br/>
        <div className="row intro-col">
          Podemos participar como único inversor en la ronda, o co-invirtiendo con otros inversores, desde VCs o Family
          Offices hasta redes de business angels o inversores particulares.
          <br/><br/>
          Cuando co-invertimos, podemos liderar la ronda con otros co-inversores o tener una posición de acompañamiento
          al lead investor.
          <br/><br/>
          Nuestro ticket mínimo de inversión es de 150k€. En fases Seed acostumbramos a ser el único inversor o
          lideramos la ronda, y en fases Growth o Pre-MAB podemos liderar o acompañar la ronda.
        </div>
      </div>
    </div>

    <div className="gap-50"/>
    <div className="gap-30"/>
    <div className="row title-col">
      Criterios de selección de empresas
    </div>
    <div className="row intro">
      El análisis de startups es una mezcla de arte y ciencia, y según la fase en la que se encuentra la empresa se
      ponderan más unos criterios que otros, pero de manera general, los principales criterios utilizados a la hora de
      seleccionar las empresas que presentamos en nuestra plataforma, los cuales son homogéneos y no discriminatorios,
      son los que se indican a continuación:
    </div>

    <div className="row">
      <div className="col-md-4 padding-l-0 center">
        <div
          className="simple-card"
          style={{height: '391px', width: '370px'}}
        >
          <div className="row  title-col center-block">
            Empresas viables
          </div>
          <div className="row  intro-card2 padding-l-r-20">
            Necesidad real detectada en un mercado grande y/o en crecimiento.
            <br/>
            <div className="gap-10"/>
            Producto o servicio que soluciona esta necesidad mejor que las soluciones existentes en el mercado.
            <br/>
            <div className="gap-10"/>
            Modelo de negocio rentable a nivel de Unit Economics, y que tenga y/o pueda generar barreras de entrada en
            el
            largo plazo sobre la competencia.
            <br/>
            <div className="gap-10"/>
            Timming de la solución adecuado a las condiciones tecnológicas y de mercado.
          </div>
        </div>
      </div>

      <div className="col-md-4 padding-l-r-10">
        <div
          className="simple-card"
          style={{height: '391px', width: '370px'}}
        >
          <div className="row center-block">
            <div className="title-col center-block">Empresas con capacidad de ejecución</div>
          </div>
          <div className="gap-20"/>
          <div className="row intro-card2 padding-l-r-20">
            Equipos excepcionales, ambiciosos, multidisciplinares, y con experiencia en el sector y en la gestión de
            empresas/equipos.
            <br/>
            <div className="gap-10"/>
            Composición del capital que garantice el control y la continuidad del equipo gestor.
            <br/>
            <div className="gap-10"/>
            Canales de captación de clientes eficientes, adecuados al pricing del producto/servicio y con potencial de
            mejora en el funnel de ventas.
            <br/>
            <div className="gap-10"/>
            Tracción demostrable en base a la evolución de KPIs y roadmap crecimiento definido.
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div
          className="simple-card"
          style={{height: '391px', width: '370px'}}
        >
          <div className="row ">
            <div className="title-col center-block">Empresas invertibles</div>
          </div>
          <div className="gap-20"/>
          <div className="row  intro-card2 padding-l-r-20">
            Modelos de negocio altamente escalables e internacionalizables.
            <br/>
            <div className="gap-10"/>
            Plan de negocio ambicioso pero realista.
            <br/>
            <div className="gap-10"/>
            Necesidad financiera adecuada para alcanzar los siguientes hitos.
            <br/>
            <div className="gap-10"/>
            Valoración adecuada a la fase y retornos de la inversión esperados.
          </div>
        </div>
      </div>

    </div>

  </div>
);

export default SelectionCriteriaSectionComponent;


// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/SelectionCriteriaSection.tsx